import { TriangleDown, TriangleRignt } from "../../assets/images/svg/svg";
import { isJson, parenthesisInNegativeValue } from "../../utils/services";
import {
  IProfitLossList,
  ITradingAccountList,
  ITradingAccountSubList,
  ProfitLossList,
  TradingAccountList,
} from "../../api/get/types";
import { Loader } from "../Loader/Loader";
import "./TradingAccount.scss";

export interface TableHeaderContentGroupProps {
  columns?: any;
  loading?: boolean;
  roleId?: number;
}
interface Props {
  checkedValues: number[];
  toggleAccordion: (id: any) => void;
  handleOnChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    item: IProfitLossList
  ) => void;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    item: ITradingAccountList
  ) => void;
  handleDoubleClick: (id: number) => void;
  tading_data: TradingAccountList | undefined;
  isLoading: boolean;
  data: ProfitLossList | undefined;
}

export const HorizontalPLAccount: React.FC<Props> = ({
  checkedValues,
  toggleAccordion,
  handleOnChange,
  handleChange,
  handleDoubleClick,
  tading_data,
  isLoading,
  data,
}) => {
  return (
    <table className="main-table">
      <tbody>
        <tr>
          {/* Direct Expense */}
          <td className="border-bottom-0">
            <table className="mini-table">
              <thead>
                <th className="width-60 text-left">Expenses</th>
                <th className="width-40" colSpan={2}>
                  Amount
                </th>
              </thead>
              {isLoading ? (
                <tr>
                  <td colSpan={4}>
                    <div className="loder-wrapper">
                      <Loader loaderType="Spinner" />
                    </div>
                  </td>
                </tr>
              ) : (
                <tbody>
                  {tading_data?.debit_data_list?.map((item, index) => {
                    const exists = checkedValues.find((val) => val === item.id);
                    return (
                      <>
                        {item.id !== null && (
                          <tr
                            onDoubleClick={() => {
                              handleDoubleClick(item.id);
                            }}
                          >
                            <td className="black-content">
                              <div className="d-flex">
                                <input
                                  className="checkbox-none"
                                  type="checkbox"
                                  id={`debit-checkbox-${index}`}
                                  name={item.ledger_name}
                                  value={item.ledger_name}
                                  checked={Boolean(exists)}
                                  onChange={(e) => handleChange(e, item)}
                                />
                                <div
                                  onClick={() => {
                                    toggleAccordion(item.id);
                                  }}
                                >
                                  {Boolean(exists) ? (
                                    <TriangleDown />
                                  ) : (
                                    <TriangleRignt />
                                  )}
                                </div>
                                <label htmlFor={`debit-checkbox-${index}`}>
                                  {item.ledger_name}
                                </label>
                              </div>
                            </td>
                            <td className="width-20"></td>
                            <td className="black-content width-20">
                              {parenthesisInNegativeValue(item.amount)}
                            </td>
                          </tr>
                        )}
                        {item.child_ledger?.map(
                          (itm: ITradingAccountSubList, idx: number) => {
                            let debitParsedJsonData = isJson(itm.ledger_name);
                            return (
                              <>
                                {debitParsedJsonData ? (
                                  <>
                                    {JSON.parse(itm.ledger_name).map(
                                      (
                                        jsonItem: ITradingAccountSubList,
                                        jsonIndex: number
                                      ) => {
                                        return (
                                          <>
                                            {jsonItem.amount === 0 ? (
                                              ""
                                            ) : (
                                              <tr
                                                className={
                                                  Boolean(exists)
                                                    ? "show"
                                                    : "dontShow"
                                                }
                                                onDoubleClick={() => {
                                                  handleDoubleClick(itm.id);
                                                }}
                                              >
                                                <td className="content width-60 padd-left">
                                                  {jsonItem.ledger_name}
                                                </td>
                                                <td className="content width-20">
                                                  {parenthesisInNegativeValue(
                                                    jsonItem.amount
                                                  )}
                                                </td>
                                                <td className="width-20"></td>
                                              </tr>
                                            )}
                                          </>
                                        );
                                      }
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {itm.amount === 0 ? (
                                      ""
                                    ) : (
                                      <tr
                                        className={
                                          Boolean(exists) ? "show" : "dontShow"
                                        }
                                        onDoubleClick={() => {
                                          handleDoubleClick(itm.id);
                                        }}
                                      >
                                        <td className="content width-60 padd-left">
                                          {itm.ledger_name}
                                        </td>
                                        <td className="content width-20">
                                          {parenthesisInNegativeValue(
                                            itm.amount
                                          )}
                                        </td>
                                        <td className="width-20"></td>
                                      </tr>
                                    )}
                                  </>
                                )}
                              </>
                            );
                          }
                        )}
                      </>
                    );
                  })}
                </tbody>
              )}
            </table>
          </td>

          {/* Direct Income */}
          <td className="border-bottom-0 ">
            <table className="mini-table">
              <thead>
                <th className="width-60 text-left">Income</th>
                <th className="width-40" colSpan={2}>
                  Amount
                </th>
              </thead>
              {isLoading ? (
                <tbody>
                  <tr>
                    <td colSpan={4}>
                      <div className="loder-wrapper">
                        <Loader loaderType="Spinner" />
                      </div>
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {tading_data?.credit_data_list?.map((item, index) => {
                    const exists = checkedValues.find((val) => val === item.id);
                    return (
                      <>
                        {item.id !== null && (
                          <tr
                            onDoubleClick={() => {
                              handleDoubleClick(item.id);
                            }}
                          >
                            <td className="black-content width-60">
                              <div className="d-flex">
                                <input
                                  className="checkbox-none"
                                  type="checkbox"
                                  id={`credit-checkbox-${index}`}
                                  name={item.ledger_name}
                                  value={item.ledger_name}
                                  checked={Boolean(exists)}
                                  onChange={(e) => handleChange(e, item)}
                                />
                                <div
                                  onClick={() => {
                                    toggleAccordion(item.id);
                                  }}
                                >
                                  {Boolean(exists) ? (
                                    <TriangleDown />
                                  ) : (
                                    <TriangleRignt />
                                  )}
                                </div>
                                <label htmlFor={`credit-checkbox-${index}`}>
                                  {item.ledger_name}
                                </label>
                              </div>
                            </td>
                            <td className="width-20"></td>
                            <td className="black-content width-20">
                              {parenthesisInNegativeValue(item.amount)}
                            </td>
                          </tr>
                        )}

                        {item.child_ledger?.map(
                          (itm: ITradingAccountSubList, idx: number) => {
                            let creditParsedJsonData = isJson(itm.ledger_name);
                            return (
                              <>
                                {creditParsedJsonData ? (
                                  <>
                                    {JSON.parse(itm.ledger_name).map(
                                      (
                                        jsonItem: ITradingAccountSubList,
                                        jsonIndex: number
                                      ) => {
                                        return (
                                          <>
                                            <tr
                                              className={
                                                Boolean(exists)
                                                  ? "show"
                                                  : "dontShow"
                                              }
                                              onDoubleClick={() => {
                                                handleDoubleClick(itm.id);
                                              }}
                                            >
                                              <td className="content width-60 padd-left">
                                                {jsonItem.ledger_name}
                                              </td>
                                              <td className="content width-20">
                                                {parenthesisInNegativeValue(
                                                  jsonItem.amount
                                                )}
                                              </td>
                                              <td className="width-20"></td>
                                            </tr>
                                          </>
                                        );
                                      }
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {itm.amount === 0 ? (
                                      ""
                                    ) : (
                                      <tr
                                        className={
                                          Boolean(exists) ? "show" : "dontShow"
                                        }
                                        onDoubleClick={() => {
                                          handleDoubleClick(itm.id);
                                        }}
                                      >
                                        <td className="content width-60 padd-left">
                                          {itm.ledger_name}
                                        </td>
                                        <td className="content width-20">
                                          {parenthesisInNegativeValue(
                                            itm.amount
                                          )}
                                        </td>
                                        <td className="width-20"></td>
                                      </tr>
                                    )}
                                  </>
                                )}
                              </>
                            );
                          }
                        )}
                      </>
                    );
                  })}
                </tbody>
              )}
            </table>
          </td>
        </tr>

        {/* Direct Footer */}
        <tr>
          {/* Direct Expense Footer */}
          <td className="vertical-bottom border-top-0">
            <table className="footer-table">
              {tading_data?.debit_data_list?.map((item, index) => {
                return (
                  <>
                    {item?.id === null ? (
                      <>
                        {item?.amount !== 0 ? (
                          <tr
                            onDoubleClick={() => {
                              handleDoubleClick(item.id);
                            }}
                          >
                            <td
                              className={
                                item.ledger_name === "Total"
                                  ? "width-60 total"
                                  : "width-60"
                              }
                              colSpan={2}
                            >
                              {item.ledger_name}
                            </td>
                            <td
                              className={
                                item.ledger_name === "Total"
                                  ? "width-40 total"
                                  : "width-40"
                              }
                            >
                              {parenthesisInNegativeValue(item.amount)}
                            </td>
                          </tr>
                        ) : (
                          <tr>
                            <td colSpan={3}></td>
                          </tr>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
            </table>
          </td>
          {/* Direct Income Footer */}
          <td className="vertical-bottom border-top-0">
            <table className="footer-table">
              {tading_data?.credit_data_list?.map((item) => {
                return (
                  <>
                    {item.id === null && (
                      <>
                        {item.amount !== 0 ? (
                          <tr
                            onDoubleClick={() => {
                              handleDoubleClick(item.id);
                            }}
                          >
                            <td
                              className={
                                item.ledger_name === "Total"
                                  ? "width-60 total"
                                  : "width-60"
                              }
                              colSpan={2}
                            >
                              {item.ledger_name}
                            </td>

                            <td
                              className={
                                item.ledger_name === "Total"
                                  ? "width-40 total"
                                  : "width-40"
                              }
                            >
                              {parenthesisInNegativeValue(item.amount)}
                            </td>
                          </tr>
                        ) : (
                          <tr>
                            <td colSpan={3}></td>
                          </tr>
                        )}
                      </>
                    )}
                  </>
                );
              })}
            </table>
          </td>
        </tr>

        <tr>
          {/* Indirect Expense */}
          <td className="border-bottom-0">
            <table className="mini-table">
              <tbody>
                {data?.debit_profit_loss?.map(
                  (item: IProfitLossList, index) => {
                    if (item.child_ledger !== null) {
                    }
                    let creditProfitJsonData = isJson(item.child_ledger);
                    const exists = checkedValues.find((val) => val === item.id);
                    return (
                      <>
                        {item.amount !== 0 && item.ledger_name !== "Total" && (
                          <tr
                            onDoubleClick={() => {
                              handleDoubleClick(item.id);
                            }}
                          >
                            <td className="width-60">
                              <div className="d-flex ">
                                {item?.child_ledger?.length > 0 ? (
                                  <>
                                    <input
                                      className="checkbox-none"
                                      type="checkbox"
                                      id={`custom-checkbox-${index}`}
                                      name={item.ledger_name}
                                      value={item.ledger_name}
                                      checked={Boolean(exists)}
                                      onChange={(e) => handleOnChange(e, item)}
                                    />
                                    <div
                                      onClick={() => {
                                        toggleAccordion(item.id);
                                      }}
                                    >
                                      {Boolean(exists) ? (
                                        <TriangleDown />
                                      ) : (
                                        <TriangleRignt />
                                      )}
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                                <label htmlFor={`custom-checkbox-${index}`}>
                                  {item.ledger_name}
                                </label>
                              </div>
                            </td>
                            <td className="width-20"></td>

                            <td className="black-content width-20">
                              {parenthesisInNegativeValue(item.amount)}
                            </td>
                          </tr>
                        )}
                        {creditProfitJsonData ? (
                          <>
                            {JSON.parse(item.child_ledger)?.map(
                              (
                                jsonItem: ITradingAccountSubList,
                                jsonIndex: number
                              ) => {
                                return (
                                  <>
                                    {jsonItem.amount === 0 ? (
                                      ""
                                    ) : (
                                      <tr
                                        key={jsonIndex}
                                        className={
                                          Boolean(exists) ? "show" : "dontShow"
                                        }
                                        onDoubleClick={() => {
                                          handleDoubleClick(jsonItem.id);
                                        }}
                                      >
                                        <td className="content width-60 padd-left">
                                          {jsonItem.ledger_name}
                                        </td>
                                        <td className="content width-20">
                                          {parenthesisInNegativeValue(
                                            jsonItem.amount
                                          )}
                                        </td>
                                        <td className="width-20"></td>
                                      </tr>
                                    )}
                                  </>
                                );
                              }
                            ) ?? ""}
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    );
                  }
                )}
              </tbody>
            </table>
          </td>
          {/* Indirect Income */}
          <td className="border-bottom-0">
            <table className="mini-table">
              <tbody>
                {data?.credit_profit_loss?.map(
                  (item: IProfitLossList, index) => {
                    let creditProfitJsonData = isJson(item.child_ledger);
                    const exists = checkedValues.find((val) => val === item.id);
                    return (
                      <>
                        {/* Net loss  */}
                        {item.amount !== 0 && item.ledger_name !== "Total" && (
                          <tr
                            onDoubleClick={() => {
                              handleDoubleClick(item.id);
                            }}
                          >
                            <td className="black-content width-60">
                              <div className="d-flex">
                                {item?.child_ledger?.length > 0 ? (
                                  <>
                                    <input
                                      className="checkbox-none"
                                      type="checkbox"
                                      id={`custom-checkbox-${index}`}
                                      name={item.ledger_name}
                                      value={item.ledger_name}
                                      checked={Boolean(exists)}
                                      onChange={(e) => handleOnChange(e, item)}
                                    />
                                    <div
                                      onClick={() => {
                                        toggleAccordion(item.id);
                                      }}
                                    >
                                      {Boolean(exists) ? (
                                        <TriangleDown />
                                      ) : (
                                        <TriangleRignt />
                                      )}
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                                <label htmlFor={`custom-checkbox-${index}`}>
                                  {item.ledger_name}
                                </label>
                              </div>
                            </td>
                            <td className="width-20"></td>
                            <td
                              className={
                                item.ledger_name === "Total"
                                  ? "width-20 total"
                                  : "width-20"
                              }
                            >
                              {parenthesisInNegativeValue(item.amount)}
                            </td>
                          </tr>
                        )}
                        {creditProfitJsonData ? (
                          <>
                            {JSON.parse(item.child_ledger)?.map(
                              (
                                jsonItem: ITradingAccountSubList,
                                jsonIndex: number
                              ) => {
                                return (
                                  <>
                                    {jsonItem.amount === 0 ? (
                                      ""
                                    ) : (
                                      <tr
                                        key={jsonIndex}
                                        className={
                                          Boolean(exists) ? "show" : "dontShow"
                                        }
                                        onDoubleClick={() => {
                                          handleDoubleClick(jsonItem.id);
                                        }}
                                      >
                                        <td className="content width-60 padd-left">
                                          {jsonItem.ledger_name}
                                        </td>
                                        <td className="content width-20">
                                          {parenthesisInNegativeValue(
                                            jsonItem.amount
                                          )}
                                        </td>
                                        <td className="width-20"></td>
                                      </tr>
                                    )}
                                  </>
                                );
                              }
                            ) ?? ""}
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    );
                  }
                )}
              </tbody>
            </table>
          </td>
        </tr>

        {/* Indirect Footer */}
        <tr>
          {/* Indirect Expense Footer */}
          <td className="vertical-bottom border-top-0">
            <table className="footer-table">
              {data?.debit_profit_loss?.map((item) => {
                return (
                  <>
                    {item.amount !== 0 && item.ledger_name === "Total" ? (
                      <tr
                        onDoubleClick={() => {
                          handleDoubleClick(item.id);
                        }}
                      >
                        <>
                          <td className="width-60 total" colSpan={2}>
                            {item.ledger_name}
                          </td>
                          <td className="width-40 total">
                            {parenthesisInNegativeValue(item.amount)}
                          </td>
                        </>
                      </tr>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
            </table>
          </td>

          {/* Indirect Footer */}
          <td className="vertical-bottom border-top-0">
            <table className="footer-table">
              {data?.credit_profit_loss?.map((item) => {
                return (
                  <>
                    {item.amount !== 0 && item.ledger_name == "Total" ? (
                      <tr
                        onDoubleClick={() => {
                          handleDoubleClick(item.id);
                        }}
                      >
                        <>
                          <td className="width-60 total" colSpan={2}>
                            {item.ledger_name}
                          </td>
                          <td className="width-40 total">
                            {parenthesisInNegativeValue(item.amount)}
                          </td>
                        </>
                      </tr>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
